import bg from "../assets/bg.png";
import profil from "../assets/person2.png";
import logo from "../assets/logo.png";
import bazen1 from "../assets/bazen1.png";
import bazen2 from "../assets/bazen2.png";
import bazen3 from "../assets/bazen3.png";
import bazen4 from "../assets/bazen4.png";
import bazen5 from "../assets/bazen5.png";
import bazen6 from "../assets/bazen6.png";
import bazen7 from "../assets/bazen7.png";
import bazen8 from "../assets/bazen8.png";
import bazen9 from "../assets/bazen9.png";
import bazen10 from "../assets/bazen10.png";
import bazen11 from "../assets/bazen11.png";
import bazen12 from "../assets/bazen12.png";
import bazen13 from "../assets/bazen13.png";
import bazen14 from "../assets/bazen14.png";
import bazen15 from "../assets/bazen15.png";
import bazen16 from "../assets/bazen16.png";
import bazen17 from "../assets/bazen17.png";
import bazen18 from "../assets/bazen18.png";
import bazen19 from "../assets/bazen19.png";
import bazen20 from "../assets/bazen20.png";

import swimming from "../assets/swimming-icon.png";
import quote from "../assets/quote.png";
import signature from "../assets/signature1.png";
import location from "../assets/location.png";

export default {
  bg,
  logo,
  quote,
  profil,
  bazen1,
  bazen2,
  bazen3,
  bazen4,
  bazen5,
  bazen6,
  bazen7,
  bazen8,
  bazen9,
  bazen10,
  bazen11,
  bazen12,
  bazen13,
  bazen14,
  bazen15,
  bazen16,
  bazen17,
  bazen18,
  bazen19,
  bazen20,
  swimming,
  signature,
  location
};
